import { backUrl } from "../utils/backURL";
import { withAuthCredentials } from "../utils/authFetchOptions";

export const getBusinessForms = async (token, mantisBusinessId) => {
    const formsReq = await fetch(`${backUrl}/mantisBusiness/customForms/business/${mantisBusinessId}`, withAuthCredentials({
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
        },
    }));
    const formsRes = await formsReq.json();
    return formsRes;
};

export const createCustomForm = async (token, mantisBusinessId, form) => {
    const formReq = await fetch(`${backUrl}/mantisBusiness/customForms`, withAuthCredentials({
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
            formData: form,
            mantisBusinessId: mantisBusinessId,
        }),
    }));
    const formRes = await formReq.json();
    return formRes;
}

export const updateCustomForm = async (token, mantisBusinessId, form, formId) => {
    const formReq = await fetch(`${backUrl}/mantisBusiness/customForms/${formId}`, withAuthCredentials({
        method: "PUT",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
            formData: form,
            mantisBusinessId: mantisBusinessId,
        }),
    }));
    const formRes = await formReq.json();
    return formRes;
}

export const deleteCustomForm = async (token, formId, mantisBusinessId) => {
    const formReq = await fetch(`${backUrl}/mantisBusiness/customForms/${formId}`, withAuthCredentials({
        method: "DELETE",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
            mantisBusinessId
        }),
    }));
    const formRes = await formReq.json();
    return formRes;
}

export const getPublicForm = async (shareId) => {
    const formReq = await fetch(`${backUrl}/mantisBusiness/customForms/public/${shareId}`, withAuthCredentials({
        method: "GET",
        headers: {
            "Content-Type": "application/json",
        },
    }));
    const formRes = await formReq.json();
    return formRes;
}

export const getFormSubmission = async (submissionId) => {
  try {
    const response = await fetch(
      `${backUrl}/mantisBusiness/customForms/submissions/${submissionId}`,
      withAuthCredentials({
        method: "GET",
        headers: {
          "Content-Type": "application/json"
          // Add any necessary auth headers
        }
      })
    );
    return await response.json();
  } catch (error) {
    console.error("Error fetching form submission:", error);
    throw error;
  }
};

export const getFormSubmissionByClientPurchaseOrderId = async (formShareId, clientPurchaseOrderId) => {
  try {
    const response = await fetch(
      `${backUrl}/mantisBusiness/customForms/submissions/purchase-order/${formShareId}?clientPurchaseOrderId=${clientPurchaseOrderId}`,
      withAuthCredentials({
        method: "GET",
        headers: {
          "Content-Type": "application/json"
          // Add any necessary auth headers
        }
      })
    );
    return await response.json();
  } catch (error) {
    console.error("Error fetching form submission:", error);
    throw error;
  }
};

export const processFormato07 = async (file) => {
  const response = await fetch(`${backUrl}/mantisBusiness/customForms/process-formato07`, withAuthCredentials({
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({
      file: file
    })
  }));
  return await response.json();
}

export const submitPublicForm = async (
  shareId,
  formValues,
  items = [],
  submissionId = null,
  clientPurchaseOrderId = null,
  products = [],
  mantisBusinessUserId = null
) => {
  try {
    const url = submissionId
      ? `${backUrl}/mantisBusiness/customForms/public/overwrite-response/${shareId}/${submissionId}`
      : `${backUrl}/mantisBusiness/customForms/public/save-response/${shareId}`;

    const method = "POST";

    const response = await fetch(url, withAuthCredentials({
      method,
      headers: {
        "Content-Type": "application/json"
        // Add any necessary auth headers
      },
      body: JSON.stringify({
        response: formValues,
        items,
        products,
        clientPurchaseOrderId,
        mantisBusinessUserId
      })
    }));
    return await response.json();
  } catch (error) {
    console.error("Error submitting form:", error);
    throw error;
  }
};
